var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTiktok = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 512",
    style: {
      enableBackground: "new 0 0 448 512"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448,209.9c-44,0.1-87-13.6-122.8-39.2v178.7c0,89.8-72.8,162.5-162.6,162.5S0.1,439,0.1,349.3 S73,186.7,162.7,186.8c7.4,0,14.9,0.5,22.3,1.5v89.9c-39.3-12.4-81.2,9.5-93.6,48.8s9.5,81.2,48.8,93.6s81.2-9.5,93.6-48.8 c2.3-7.2,3.4-14.8,3.4-22.4V0h88c-0.1,7.4,0.6,14.9,1.9,22.2l0,0c6.2,33,25.7,62,53.9,80.2c19.9,13.1,43.2,20.1,67,20.1V209.9z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTiktok);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tiktok.f588e96f36221e02b06fc9794b4064e2.svg";